module.exports = "/images/vendor/desiigner-svg/svg/places/urban.svg?dd538e2649ebedc01317b13a1860a81e";